import axios from 'axios'
import searchbarFn from '../api/searchbar'
export default function ({ app }, inject) {
  const options = {
    timeout: 15000, // 15 segundos para esperar respuesta
    headers: {
      common: {
        'Content-Type': 'application/json'
      },
      post: {}
    }
  }
  const pubId = app.i18n.locales.find((lang) => lang.code === app.i18n.locale).pubId
  const apiUrl = process.env.environment.api.url

  const api = axios.create({
    ...options,
    baseURL: apiUrl // Configura baseURL aquí
  })
  const prodWithAxios = searchbarFn(api, pubId)
  inject('apiSearchbar', prodWithAxios())
}
